<template>
  <div class="flex flex-1 min-h-0">
    <div class="flex flex-col w-full">
      <div class="flex space-x-5 mb-4 items-center">
        <router-link
          v-for="tab in tabs"
          :key="tab.value"
          class="cursor-pointer font-bold m-0 text-lg text-black nav-item"
          :to="{ name: tab.value }"
        >
          {{ tab.name }}
        </router-link>
      </div>

      <div class="flex flex-1 min-h-0">
        <router-view :blocks="blocks" :pages="pages" />
      </div>
    </div>

    <div class="flex-shrink-0 -mt-23">
      <PhonePreview :blocks="blocks" :pages="pages" />
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router/composables'
import { useBlocks } from '../composables/blocks'
import { usePages } from '../composables/pages'
import PhonePreview from './phone-preview'

const tabs = [
  {
    value: 'articles-pages',
    name: 'Страницы'
  },
  {
    value: 'articles-blocks',
    name: 'Блоки'
  }
]

export default {
  components: {
    PhonePreview
  },
  setup () {
    const router = useRouter()
    const route = useRoute()
    const { blocks, getBlocks } = useBlocks({
      router,
      route
    })
    const { pages, getPages } = usePages({
      router,
      route
    })

    onMounted(() => {
      blocks.value = getBlocks()
      pages.value = getPages()
    })

    return {
      tabs,
      blocks,
      pages
    }
  }
}
</script>

<style lang="postcss" scoped>
.nav-item:not(.router-link-active) {
  @apply opacity-30;
}
</style>
